import { HttpClient } from "@angular/common/http";
import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { environment } from "../../../environments/environment";
import { cityList } from '../data/cityList'

@Component({
  selector: 'be-our-dealer',
  templateUrl: './be-our-dealer.component.html',
  styleUrls: []
})
export class BeOurDelaerComponent {
  loading = false;
  cityList: any = [];

  dealerForm: FormGroup;

  nameValid: boolean = true;
  mailValid: boolean = true;
  phoneValid: boolean = true;
  provinceValid: boolean = true;
  districtValid: boolean = true;
  website: boolean = true;
  formValid: boolean = false;

  constructor(private http: HttpClient) {
    window.scrollTo(0, 0);
    this.cityList = cityList;
    this.dealerForm = new FormGroup({
      company: new FormControl(),
      name: new FormControl('', [
        Validators.required,
      ]),
      email: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)
      ]),
      phone: new FormControl('', [
        Validators.required,
      ]),
      province: new FormControl('', [
        Validators.required
      ]),
      district: new FormControl('', [
        Validators.required
      ]),
      website: new FormControl(),
      message: new FormControl('', [
        Validators.required,
      ])
    });
    this.dealerForm.controls["province"].setValue(0);
  }
  onSubmit() {
    this.loading = true;
    if (!this.dealerForm.controls['name'].valid) {
      this.nameValid = false;
    } else this.nameValid = true;

    if (!this.dealerForm.controls['email'].valid) {
      this.mailValid = false;
    } else this.mailValid = true;

    if (!this.dealerForm.controls['phone'].valid) {
      this.phoneValid = false;
    } else this.phoneValid = true;

    if (this.dealerForm.controls['province'].value == '0') {
      this.provinceValid = false;
    } else this.provinceValid = true;

    if (!this.dealerForm.controls['district'].valid) {
      this.districtValid = false;
    } else this.districtValid = true;

    if (this.nameValid && this.mailValid && this.phoneValid && this.provinceValid && this.districtValid)
      this.saveInfo();
    else this.loading = false;
  }
  checkPhone() {
    if (this.dealerForm.controls["phone"].value[0] == '0')
      this.dealerForm.controls["phone"].setValue(this.dealerForm.controls["phone"].value.substr(1));
  }
  saveInfo() {
    let url = environment.notificationUrl + "/v1/notifications/email"
    let raw = this.dealerForm.getRawValue();
    let req = {
      subject: "(WEB) Bayimiz Olun Başvurusu",
      params: {
        "Firma İsmi": raw.company,
        "Yetkili Ad Soyad": raw.name,
        "Telefon": raw.phone,
        "E-Posta": raw.email,
        "İl": raw.province,
        "İlçe": raw.district,
        "Web Sitesi": raw.website,
        "Mesaj": raw.message
      }
    };
    this.http
      .post(url, req)
      .subscribe(
        responseData => {
          this.loading = false;
          this.formValid = true;
        },
        error => {
          this.loading = false;
          this.formValid = true;
        }
      );
  }
}
